import React from "react";
import { EntityType } from "@common/Common.types.ts";
import {
    contractsIcon,
    frameworkIcon,
    internalAssessments,
    legalEntitiesIcon,
    policiesIcon,
    processesIcon,
    processingActivitiesIcon,
    riskAssessmentIcon,
    systemsMenuIcon,
    taskManagementIcon,
} from "@common/icons.tsx";
import Unassigned from "../../../taskManagement/task/unassigned.svg?react";
import { exhaustiveGuard } from "@common/utilities.ts";

export function getEntityTypeIcon(type: EntityType): React.ReactNode {
    switch (type) {
        case EntityType.IncidentLog:
        case EntityType.Policy:
            return policiesIcon;
        case EntityType.LegalEntity:
            return legalEntitiesIcon;
        case EntityType.LegalEntityDocument:
            return policiesIcon;
        case EntityType.ProcessingActivity:
            return processingActivitiesIcon;
        case EntityType.Process:
            return processesIcon;
        case EntityType.Risk:
            return riskAssessmentIcon;
        case EntityType.System:
            return systemsMenuIcon;
        case EntityType.AnnualWheelActivity:
        case EntityType.Task:
            return taskManagementIcon;
        case EntityType.LegalEntityAuditGroup:
        case EntityType.LegalEntityAudit:
        case EntityType.InternalAssessment:
        case EntityType.InternalAssessmentGroup:
        case EntityType.LegalEntityClassification:
            return internalAssessments;
        case EntityType.Contract:
            return contractsIcon;
        case EntityType.ContractDocument:
            return contractsIcon;
        case EntityType.User:
            return <Unassigned />;
        case EntityType.FrameworkControl:
            return frameworkIcon;
        case EntityType.ContractType:
        case EntityType.BusinessArea:
        case EntityType.EntityTemplate:
        case EntityType.PaymentTerm:
        case EntityType.Tag:
        case EntityType.TaskDocument:
        case EntityType.SystemDocument:
        case EntityType.PolicyDocument:
        case EntityType.IncidentLogDocument:
        case EntityType.ProcessDocument:
        case EntityType.ProcessingActivityDocument:
        case EntityType.DocumentType:
        case EntityType.ComplianceArea:
        case EntityType.DeletionPeriod:
        case EntityType.Certification:
        case EntityType.SecurityMeasures:
        case EntityType.DataCategory:
        case EntityType.DataSubject:
        case EntityType.LegalBasis:
        case EntityType.Organisation:
            return undefined;
        default:
            exhaustiveGuard(type);
    }
}
